module.exports = __webpack_public_path__ + "img/review(1).8ddf2883.svg";